module.exports = __webpack_public_path__ + "static/dr-beach-e2154f26be667049bd43e99caa881fa3.jpg";